/* =====================================================================
   Superette × Fish Wishlist v2 — drawer tabs: Wishlists · Waitlist · Brands (D2, v1.17)
   ⚠ JavaScript. Never paste into the Fish Wishlist Custom CSS box.
   · one group at a time instead of one long scroll (styles in sp-wishlist-clean.css / -d2.css)
   · the tab bar sits outside the scrolling area, fixed under the header — only the lists scroll
   · small counts on each tab; the drawer remembers the last tab
   · Shopping preference sits at the bottom of the Wishlists tab (grey box)
   · "View" on a Notify me toast opens the Waitlist tab; "View" / "Change" on a wishlist toast
     opens Wishlists
   · friendly empty states for Waitlist and Brands
   · the Waitlist tab always shows every product, fully open (no View all / View less)
   · an empty wishlist has no View all: its message plus an underlined line by shopping preference
     (Shop Women’s New Arrivals / Shop Men’s New Arrivals / Shop New Arrivals) show straight away
   · your own lists show in the order they were created (oldest first, Nicole's / My wishlist always
     first) in this drawer and in the save drawer — Fish lists them by its stored order otherwise
   · only one list of your own: it opens by itself showing every product (View less still closes
     it); with two or more lists they stay stacked and closed with the row of images
   · moving between lists: products can be dragged (the image link no longer steals the drag), and a
     quiet grey line sits under the tabs, above the lists, whenever there's another list
   · save drawer: a new list can't be created without a name (Fish would call it "My wishlist")
   · Waitlist tidy-up: when the size they signed up for is in stock (and the product isn't a
     label: coming soon launch) it moves to the main wishlist — it's ready to shop
   · the wishlist ribbon (cards + PDP) only fills for the shopper's own lists — signing up for Notify
     me (Waitlist) doesn't fill it; tapping it still opens the save drawer to add it to a list
   · PDP: sizes they've signed up for show a khaki tick instead of the envelope (same as the cards).
     The theme rebuilds the size buttons after every size change, so the tick is put back the moment
     that happens (no envelope flash), and the envelopes wait a beat on load until we know
   · tapping a size they're already on the list for (card tick, quick add, PDP "You're on the list")
     just says "You're already on the list" — no second sign-up
   · Rename: an open list of your own (View all) has a small Rename link right under its name; the name is
     edited in place and saved to Fish's list names (Nicole's / My wishlist keeps its name)
   · "Create new list" at the end of the Wishlists tab (same Fish lists as the save drawer: the next
     free WL slot; up to 9 lists of your own)
   ===================================================================== */
(() => {
  const KEY = 'spWlTab';
  const TABS = [
    { id: 'lists', label: 'Wishlists' },
    { id: 'waitlist', label: 'Waitlist' },
    { id: 'brands', label: 'Brands' },
  ];
  const SKIP = ['WL10', 'WL12'];
  const store = {
    get() { try { return localStorage.getItem(KEY) || 'lists'; } catch (e) { return 'lists'; } },
    set(v) { try { localStorage.setItem(KEY, v); } catch (e) {} },
  };
  let next = null; // a tab requested by a toast, used when the drawer next opens

  const lists = () => (window.FishWishlist && window.FishWishlist.wishlists) || {};
  const counts = () => {
    const l = lists();
    let own = 0;
    Object.keys(l).forEach((id) => { if (!SKIP.includes(id) && Array.isArray(l[id])) own += l[id].length; });
    const wait = Array.isArray(l.WL10) ? l.WL10.length : 0;
    const saved = window.FishWishlist && window.FishWishlist.savedCollections;
    const brands = Array.isArray(saved) ? saved.length : (saved && typeof saved === 'object' ? Object.keys(saved).length : 0);
    return { lists: own, waitlist: wait, brands };
  };

  // Waitlist tab: the list is always open
  const openWaitlist = (drawer) => {
    const t = drawer.querySelector('fw2-list-card[data-id="WL10"] .fw2-toggle[aria-expanded="false"]');
    if (t) t.click();
  };

  const setTab = (drawer, id, remember = true) => {
    if (!TABS.some((t) => t.id === id)) id = 'lists';
    drawer.dataset.spTab = id;
    drawer.querySelectorAll('.sp-tabs__tab').forEach((b) => {
      const on = b.dataset.tab === id;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-selected', on ? 'true' : 'false');
      b.tabIndex = on ? 0 : -1;
    });
    if (remember) store.set(id);
    if (id === 'waitlist') openWaitlist(drawer);
    const body = drawer.querySelector('.fw2-body');
    if (body) body.scrollTop = 0;
  };

  const empty = (pane, id, html) => {
    let el = pane.querySelector(`:scope > .sp-tab-empty[data-for="${id}"]`);
    if (!el) {
      el = document.createElement('div');
      el.className = 'sp-tab-empty';
      el.dataset.for = id;
      el.innerHTML = html;
      pane.appendChild(el);
    }
    return el;
  };

  /* ---------- Create new list (Wishlists tab) ---------- */
  const app = () => window.FishWishlist;
  const toast = (text) => {
    let el = document.querySelector('.sp-wl-toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'sp-wl-toast';
      el.setAttribute('role', 'status');
      el.innerHTML = '<span class="sp-wl-toast__text"></span><button type="button" class="sp-wl-toast__action"></button>';
      document.body.appendChild(el);
    }
    el.querySelector('.sp-wl-toast__text').textContent = text;
    const b = el.querySelector('.sp-wl-toast__action');
    b.hidden = true;
    setTimeout(() => el.classList.add('is-visible'), 20);
    clearTimeout(el._t);
    el._t = setTimeout(() => el.classList.remove('is-visible'), 4000);
  };
  const createList = async (drawer, box) => {
    const F = app();
    const input = box.querySelector('.sp-new-list__input');
    const err = box.querySelector('.sp-new-list__error');
    const btn = box.querySelector('.sp-new-list__create');
    const name = input.value.trim();
    err.textContent = '';
    if (!name) { err.textContent = 'Please give your list a name.'; input.focus(); return; }
    if (!F || typeof F.addWishlist !== 'function') { err.textContent = 'Something went wrong. Please try again.'; return; }
    const id = typeof F.findNextWishlistId === 'function' ? F.findNextWishlistId() : null;
    if (!id) { err.textContent = 'You’ve reached the maximum of 9 lists.'; return; }
    btn.disabled = true;
    try {
      F.addWishlist(name, id);
      // an empty list is only kept once its name is saved too
      if (F.dataConnector && typeof F.dataConnector.setMetadata === 'function') await F.dataConnector.setMetadata(F.metadata);
      if (F.elements && F.elements.wishlistsDrawer && typeof F.elements.wishlistsDrawer.renderWishlistElements === 'function') F.elements.wishlistsDrawer.renderWishlistElements();
      input.value = '';
      box.classList.remove('is-open');
      toast(`Created ${name}`);
      setTimeout(() => {
        const card = drawer.querySelector(`fw2-list-card[data-id="${id}"]`);
        if (card) card.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }, 400);
    } catch (e) {
      err.textContent = 'Something went wrong. Please try again.';
    } finally {
      btn.disabled = false;
    }
  };
  const newListBox = (drawer, pane) => {
    if (!(window.spWishlist && window.spWishlist.loggedIn)) return;
    let box = pane.querySelector(':scope > .sp-new-list');
    if (box) return;
    box = document.createElement('div');
    box.className = 'sp-new-list';
    box.innerHTML = `<button type="button" class="sp-new-list__toggle" aria-expanded="false">Create new list</button>
      <form class="sp-new-list__form" novalidate>
        <label class="sp-new-list__label" for="SpNewListName">New list</label>
        <div class="sp-new-list__row">
          <input class="sp-new-list__input" id="SpNewListName" name="name" type="text" maxlength="40" placeholder="List name" autocomplete="off">
          <button type="submit" class="sp-new-list__create">Create</button>
        </div>
        <p class="sp-new-list__error" role="alert"></p>
      </form>`;
    pane.appendChild(box);
    const toggle = box.querySelector('.sp-new-list__toggle');
    toggle.addEventListener('click', () => {
      const open = !box.classList.contains('is-open');
      box.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) setTimeout(() => box.querySelector('.sp-new-list__input').focus(), 50);
    });
    box.querySelector('form').addEventListener('submit', (e) => { e.preventDefault(); createList(drawer, box); });
  };

  // empty wishlists: one underlined link, chosen by the shopping preference box (data-mode="set:Womens" …)
  const emptyCta = (drawer) => {
    const mode = ((drawer.querySelector('.sp-pref') || {}).dataset || {}).mode || '';
    const pref = mode.indexOf('set:') === 0 ? mode.slice(4) : '';
    if (pref === 'Womens') return { label: 'Shop Women’s New Arrivals', url: '/collections/womens-new-arrivals' };
    if (pref === 'Mens') return { label: 'Shop Men’s New Arrivals', url: '/collections/mens-new-arrivals' };
    return { label: 'Shop New Arrivals', url: '/collections/new-arrivals' };
  };
  // V3 · coming soon, by shopping preference: same words, Coming Soon opens with its Gender filter set
  const comingSoonCta = (drawer) => {
    const mode = ((drawer.querySelector('.sp-pref') || {}).dataset || {}).mode || '';
    const pref = mode.indexOf('set:') === 0 ? mode.slice(4) : '';
    if (pref === 'Womens') return { label: 'Shop coming soon', url: '/collections/coming-soon?&sort_by=manual&filter.p.vendor-search=&filter.p.m.custom.sup_product_collection_gender=gid%3A%2F%2Fshopify%2FMetaobject%2F197195727099&filter.v.price.gte=&filter.v.price.lte=' };
    if (pref === 'Mens') return { label: 'Shop coming soon', url: '/collections/coming-soon?&sort_by=manual&filter.p.vendor-search=&filter.p.m.custom.sup_product_collection_gender=gid%3A%2F%2Fshopify%2FMetaobject%2F197195825403&filter.v.price.gte=&filter.v.price.lte=' };
    return { label: 'Shop coming soon', url: '/collections/coming-soon?&sort_by=manual&filter.p.vendor-search=&filter.v.price.gte=&filter.v.price.lte=' };
  };
  const markEmpty = (drawer) => {
    const cta = emptyCta(drawer);
    drawer.querySelectorAll('.fw2-pane--lists fw2-list-card').forEach((card) => {
      if (SKIP.includes(card.dataset.id)) return;
      const msg = card.querySelector('.fw2-empty');
      const isEmpty = !!msg && !card.querySelector('fw2-item-row, .fw2-thumb, .sp-strip__item');
      if (card.classList.contains('sp-card--empty') !== isEmpty) card.classList.toggle('sp-card--empty', isEmpty);
      let a = card.querySelector('.sp-empty-cta');
      if (!isEmpty) { if (a) a.remove(); return; }
      if (!a) { a = document.createElement('a'); a.className = 'sp-empty-cta'; msg.after(a); }
      if (a.getAttribute('href') !== cta.url) a.setAttribute('href', cta.url);
      if (a.textContent !== cta.label) a.textContent = cta.label;
    });
  };

  // own lists by time of creation (Fish metadata createdAt). A list saved without a date sorts just
  // after the nearest lower-numbered list that has one.
  const created = () => {
    const meta = (window.FishWishlist && Array.isArray(window.FishWishlist.metadata)) ? window.FishWishlist.metadata : [];
    const at = {};
    meta.forEach((m) => { if (m && m.id) at[m.id] = typeof m.createdAt === 'number' ? m.createdAt : null; });
    const num = (id) => parseInt(String(id).replace(/\D/g, ''), 10) || 0;
    const key = (id) => {
      if (at[id] != null) return at[id];
      let best = null;
      Object.keys(at).forEach((o) => { if (at[o] != null && num(o) < num(id) && (best === null || num(o) > num(best))) best = o; });
      return best ? at[best] + num(id) / 1000 : Number.MAX_SAFE_INTEGER - 1000 + num(id);
    };
    return key;
  };
  const sortOwn = (items, idOf) => {
    const own = items.filter((el) => { const id = idOf(el); return id && id !== 'WL1' && !SKIP.includes(id); });
    if (own.length < 2) return;
    const key = created();
    const sorted = own.slice().sort((a, b) => key(idOf(a)) - key(idOf(b)));
    if (sorted.every((el, i) => el === own[i])) return;
    const marks = own.map((el) => { const c = document.createComment('sp'); el.before(c); return c; });
    marks.forEach((c, i) => { c.after(sorted[i]); });
    marks.forEach((c) => c.remove());
  };
  const sortLists = (drawer) => sortOwn([...drawer.querySelectorAll('.fw2-pane--lists fw2-list-card[data-id]')], (el) => el.dataset.id);
  const sortSaveDrawer = () => document.querySelectorAll('atw-drawer').forEach((d) => {
    sortOwn([...d.querySelectorAll('atw-drawer-item[data-id]')], (el) => el.dataset.id);
  });

  /* ---------- Rename a list (open lists of your own; not the default list) ---------- */
  const NO_RENAME = ['WL1', 'WL10', 'WL12'];
  const renameList = async (card, form) => {
    const F = app();
    const id = card.dataset.id;
    const input = form.querySelector('.sp-rename__input');
    const err = form.querySelector('.sp-rename__error');
    const save = form.querySelector('.sp-rename__save');
    const name = input.value.trim();
    err.textContent = '';
    if (!name) { err.textContent = 'Please give your list a name.'; input.focus(); return; }
    const meta = F && Array.isArray(F.metadata) ? F.metadata.find((m) => m && m.id === id) : null;
    if (!meta || !F.dataConnector || typeof F.dataConnector.setMetadata !== 'function') { err.textContent = 'Something went wrong. Please try again.'; return; }
    if (meta.name === name) { card.classList.remove('sp-renaming'); form.remove(); return; }
    const before = meta.name;
    save.disabled = true;
    try {
      meta.name = name;
      await F.dataConnector.setMetadata(F.metadata);
      card.classList.remove('sp-renaming');
      form.remove();
      if (F.elements && F.elements.wishlistsDrawer && typeof F.elements.wishlistsDrawer.renderWishlistElements === 'function') F.elements.wishlistsDrawer.renderWishlistElements();
      else { const n = card.querySelector('.fw2-card__name'); if (n) n.textContent = name; }
      toast(`Renamed to ${name}`);
    } catch (e) {
      meta.name = before;
      err.textContent = 'Something went wrong. Please try again.';
    } finally {
      save.disabled = false;
    }
  };
  const openRename = (card) => {
    if (card.querySelector('.sp-rename')) return;
    const header = card.querySelector('.fw2-card__header');
    const current = ((card.querySelector('.fw2-card__name') || {}).textContent || '').trim();
    if (!header) return;
    const form = document.createElement('form');
    form.className = 'sp-rename';
    form.noValidate = true;
    form.innerHTML = `<label class="visually-hidden" for="SpRename-${card.dataset.id}">List name</label>
      <div class="sp-rename__row">
        <input class="sp-rename__input" id="SpRename-${card.dataset.id}" type="text" maxlength="40" autocomplete="off">
        <button type="submit" class="sp-rename__save">Save</button>
        <button type="button" class="sp-rename__cancel">Cancel</button>
      </div>
      <p class="sp-rename__error" role="alert"></p>`;
    header.after(form);
    const input = form.querySelector('.sp-rename__input');
    input.value = current;
    card.classList.add('sp-renaming');
    const close = () => { card.classList.remove('sp-renaming'); form.remove(); };
    form.addEventListener('submit', (e) => { e.preventDefault(); renameList(card, form); });
    form.querySelector('.sp-rename__cancel').addEventListener('click', close);
    input.addEventListener('keydown', (e) => { if (e.key === 'Escape') { e.stopPropagation(); close(); } });
    setTimeout(() => { input.focus(); input.select(); }, 30);
  };
  const renameButtons = (drawer) => {
    drawer.querySelectorAll('.fw2-pane--lists fw2-list-card[data-id]').forEach((card) => {
      if (NO_RENAME.includes(card.dataset.id) || card.closest('.fw2-buy-again-slot--lists')) return;
      const header = card.querySelector('.fw2-card__header');
      if (!header || card.querySelector('.sp-rename-btn')) return;
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'sp-rename-btn';
      b.textContent = 'Rename';
      b.setAttribute('aria-label', 'Rename list');
      b.addEventListener('click', (e) => { e.stopPropagation(); openRename(card); });
      header.after(b); // directly under the list name
    });
  };

  // only one list of your own: open it (once per visit; View less closes it and it stays closed)
  const autoOpen = (drawer) => {
    const own = [...drawer.querySelectorAll('.fw2-pane--lists fw2-list-card[data-id]')].filter((c) => !SKIP.includes(c.dataset.id) && !c.closest('.fw2-buy-again-slot--lists'));
    if (own.length !== 1) return;
    const card = own[0];
    if (!card.querySelector('fw2-item-row, .fw2-thumb, .sp-strip__item')) return; // empty: it has its own message
    if ((drawer.dataset.spClosed || '').split(',').includes(card.dataset.id)) return;
    const t = card.querySelector('.fw2-toggle[aria-expanded="false"]');
    if (t) t.click();
  };
  document.addEventListener('click', (e) => {
    if (!e.isTrusted) return;
    const t = e.target.closest && e.target.closest('fw2-drawer fw2-list-card[data-id] .fw2-toggle[aria-expanded="true"]');
    if (!t) return;
    const drawer = t.closest('fw2-drawer');
    drawer.dataset.spClosed = `${drawer.dataset.spClosed || ''},${t.closest('fw2-list-card').dataset.id}`;
  }, true);

  /* ---------- moving between lists: make it obvious and make it work ---------- */
  const touch = () => !window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const moveHelp = (drawer) => {
    const own = [...drawer.querySelectorAll('.fw2-pane--lists fw2-list-card[data-id]')].filter((c) => !SKIP.includes(c.dataset.id));
    // the product image is a link, and a dragged link wins over the row: let the row take the drag
    own.forEach((c) => c.querySelectorAll('fw2-item-row .fw2-row__image a:not([draggable="false"]), fw2-item-row .fw2-row__image img:not([draggable="false"])').forEach((n) => n.setAttribute('draggable', 'false')));
    // one quiet grey line under the tabs, above the lists, whenever there's somewhere to move to
    const pane = drawer.querySelector('.fw2-pane--lists');
    const withItems = own.filter((c) => c.querySelector('fw2-item-row, .fw2-thumb, .sp-strip__item'));
    let hint = pane && pane.querySelector(':scope > .sp-move-hint');
    if (!pane || own.length < 2 || !withItems.length) { if (hint) hint.remove(); return; }
    const text = touch() ? 'Press and hold the item to move to another list.' : 'Drag the item to move to another list.';
    if (!hint) { hint = document.createElement('p'); hint.className = 'sp-move-hint'; pane.appendChild(hint); }
    if (hint.textContent !== text) hint.textContent = text;
  };

  const render = (drawer) => {
    const pane = drawer.querySelector('.fw2-pane--lists');
    if (!pane) return;
    const panel = drawer.querySelector('.fw2-panel');
    const body = drawer.querySelector('.fw2-body');
    let bar = drawer.querySelector('.sp-tabs');
    if (bar && panel && body && bar.parentElement !== panel) { panel.insertBefore(bar, body); }
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'sp-tabs';
      bar.setAttribute('role', 'tablist');
      bar.setAttribute('aria-label', 'Saved');
      bar.innerHTML = TABS.map((t) => `<button type="button" class="sp-tabs__tab" role="tab" data-tab="${t.id}">${t.label}<span class="sp-tabs__count"></span></button>`).join('');
      if (panel && body) panel.insertBefore(bar, body); else pane.prepend(bar);
      bar.addEventListener('click', (e) => {
        const b = e.target.closest('.sp-tabs__tab');
        if (b) setTab(drawer, b.dataset.tab);
      });
      bar.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        const ids = TABS.map((t) => t.id);
        const i = ids.indexOf(drawer.dataset.spTab || 'lists');
        const n = ids[(i + (e.key === 'ArrowRight' ? 1 : ids.length - 1)) % ids.length];
        setTab(drawer, n);
        const nb = bar.querySelector(`[data-tab="${n}"]`);
        if (nb) nb.focus();
      });
    }
    const c = counts();
    bar.querySelectorAll('.sp-tabs__tab').forEach((b) => {
      const n = c[b.dataset.tab];
      const span = b.querySelector('.sp-tabs__count');
      const text = n ? String(n) : '';
      if (span.textContent !== text) span.textContent = text;
    });
    // empty states (shown by CSS only on their own tab, and only when there's nothing there)
    empty(pane, 'waitlist', '<p class="sp-tab-empty__title">Nothing on your waitlist yet</p><p class="sp-tab-empty__copy">Tap Notify me on a coming soon or sold out size and we’ll let you know the moment it lands.</p><a class="sp-tab-empty__link" href="/collections/coming-soon">Shop coming soon</a>');
    // the link follows the shopping preference (it can load after the drawer): Coming Soon with Womens / Mens filter, or all
    const csLink = pane.querySelector(':scope > .sp-tab-empty[data-for="waitlist"] .sp-tab-empty__link');
    if (csLink) {
      const cs = comingSoonCta(drawer);
      if (csLink.getAttribute('href') !== cs.url) csLink.setAttribute('href', cs.url);
      if (csLink.textContent !== cs.label) csLink.textContent = cs.label;
    }
    empty(pane, 'brands', '<p class="sp-tab-empty__title">No brands followed yet</p><p class="sp-tab-empty__copy">Follow your favourite brands to be notified of their new arrivals.</p><a class="sp-tab-empty__link" href="/pages/brands">Shop brands</a>');
    drawer.classList.toggle('sp-has-waitlist', !!pane.querySelector('fw2-list-card[data-id="WL10"] .sp-strip__item, fw2-list-card[data-id="WL10"] .fw2-thumb, fw2-list-card[data-id="WL10"] fw2-item-row'));
    newListBox(drawer, pane);
    markEmpty(drawer);
    sortLists(drawer);
    autoOpen(drawer);
    renameButtons(drawer);
    moveHelp(drawer);
    if (typeof markReady === 'function') { markReady(); seeReady(drawer); }
    drawer.classList.toggle('sp-has-brands', !!pane.querySelector('.fw2-collections-slot--lists .fw2-collection'));
    if (!drawer.dataset.spTab) setTab(drawer, store.get(), false);
    else if (drawer.dataset.spTab === 'waitlist') openWaitlist(drawer);
  };

  // save drawer: no unnamed lists (Fish would name it "My wishlist" and add the product to it)
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!(form && form.closest && form.closest('atw-drawer new-wishlist-form, atw-drawer .fw2-atw__new'))) return;
    const input = form.querySelector('input[type="text"], input.fw2-input:not([type="submit"])');
    if (!input || input.value.trim()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    let err = form.querySelector('.error-message');
    if (!err) { err = document.createElement('div'); err.className = 'error-message'; form.appendChild(err); }
    err.textContent = 'Please give your list a name.';
    err.style.display = 'block';
    input.focus();
  }, true);
  document.addEventListener('click', (e) => {
    const b = e.target.closest && e.target.closest('atw-drawer new-wishlist-form [type="submit"], atw-drawer .fw2-atw__new [type="submit"]');
    if (!b || !b.form) return;
    const input = b.form.querySelector('input[type="text"], input.fw2-input:not([type="submit"])');
    if (input && !input.value.trim()) { e.preventDefault(); e.stopImmediatePropagation(); b.form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true })); }
  }, true);

  /* ---------- Waitlist tidy-up: now available → main wishlist ----------
     The size they signed up for is in stock and the product isn't a coming soon launch: it's ready
     to shop, so it isn't a waitlist item any more. Move it to the default list (WL1) and say so once.
     Fish adds / removes through its own hidden button (same as sp-list-move.js / sp-notify-me.js). */
  const MAIN = 'WL1';
  const WAIT = 'WL10';
  const WAIT_TAGS = ['label: coming soon'];
  const vid = (v) => String(v || '').replace(/[^\d]/g, '');
  const has = (list, id) => (Array.isArray(lists()[list]) ? lists()[list] : []).some((x) => vid(x && x.id) === vid(id));
  const sleep = (ms) => new Promise((r) => setTimeout(r, ms));
  let fishQueue = Promise.resolve();
  const fishSet = (variantId, listId, want) => (fishQueue = fishQueue.then(async () => {
    const id = vid(variantId);
    const wrap = document.createElement('div');
    wrap.innerHTML = `<wishlist-button-pdp data-wishlist-id="${listId}" role="button" class="fish-wishlist-button--pdp sp-move-fish" aria-hidden="true" tabindex="-1" data-variant-id="${id}" data-preselected-id="${id}" data-is-added="false"></wishlist-button-pdp>`;
    const fish = wrap.firstElementChild;
    document.body.appendChild(fish);
    const wanted = want ? 'true' : 'false';
    try {
      await sleep(600);
      if (fish.dataset.isAdded === wanted) return true;
      const openBefore = new Set([...document.querySelectorAll('atw-drawer')].filter((d) => d.dataset.open === 'true'));
      fish.click();
      const end = Date.now() + 4000;
      while (Date.now() < end && fish.dataset.isAdded !== wanted) await sleep(100);
      await sleep(150);
      // close only a drawer this silent save opened — never one the shopper is using
      document.querySelectorAll('atw-drawer').forEach((d) => { if (d.dataset.open === 'true' && !openBefore.has(d) && typeof d.close === 'function') d.close(); });
      return fish.dataset.isAdded === wanted;
    } catch (e) { return false; } finally { fish.remove(); }
  }));
  const noLongerWaiting = (item) => {
    if (!item || item.available !== true) return false;
    const tags = (Array.isArray(item.tags) ? item.tags : String(item.tags || '').split(',')).map((t) => String(t).trim().toLowerCase());
    return !WAIT_TAGS.some((t) => tags.includes(t));
  };
  let tidying = false;
  // V3: the tidy-up only runs while the shopper isn't using a drawer and isn't mid sign-in return
  // (it used to run straight after sign-in and close the drawer that had just opened)
  const busy = () => {
    let pending = false;
    try { pending = !!sessionStorage.getItem('spWishlistIntent'); } catch (e) { /* */ }
    return pending || [...document.querySelectorAll('fw2-drawer, atw-drawer, quick-add-drawer, cart-drawer')].some((d) => d.dataset.open === 'true' || d.classList.contains('active') || d.hasAttribute('open'));
  };
  const tidyWaitlist = async () => {
    if (tidying || !(window.spWishlist && window.spWishlist.loggedIn)) return;
    const idleBy = Date.now() + 60000;
    while (busy() && Date.now() < idleBy) await sleep(800);
    if (busy()) return; // next page view
    const wait = lists()[WAIT];
    if (!Array.isArray(wait) || !wait.length) return;
    const tried = (() => { try { return JSON.parse(sessionStorage.getItem('spWaitTidy') || '[]'); } catch (e) { return []; } })();
    const due = wait.filter((x) => noLongerWaiting(x) && !tried.includes(vid(x.id)));
    if (!due.length) return;
    tidying = true;
    const root = document.documentElement;
    root.dataset.spSilent = 'true';
    root.dataset.spMoving = 'true';
    const moved = [];
    try {
      for (const item of due) {
        const id = vid(item.id);
        tried.push(id);
        try { sessionStorage.setItem('spWaitTidy', JSON.stringify(tried.slice(-200))); } catch (e) { /* once per visit at most */ }
        const added = has(MAIN, id) || (await fishSet(id, MAIN, true));
        const removed = added && (await fishSet(id, WAIT, false));
        if (added && removed) moved.push(item);
      }
    } finally {
      setTimeout(() => { delete root.dataset.spSilent; delete root.dataset.spMoving; }, 600);
      tidying = false;
    }
    if (!moved.length) return;
    const st = readyState();
    moved.forEach((x) => { const id = vid(x.id); if (!st.ids.includes(id)) st.ids.push(id); });
    st.seen = false;
    st.at = Date.now();
    saveReady(st);
    markReady();
    const name = (document.querySelector(`fw2-drawer fw2-list-card[data-id="${MAIN}"] .fw2-card__name`) || {}).textContent || 'your wishlist';
    const one = moved[0];
    const title = (one && (one.productTitle || one.name)) || 'An item';
    toast(moved.length === 1 ? `${title} is now available. Moved to ${name.trim()}.` : `${moved.length} Waitlist items are now available. Moved to ${name.trim()}.`);
  };
  /* ---------- V3 · back in stock: Waitlist items that moved to the wishlist stand out ----------
     · a red dot on the header bookmark until the Saved drawer is opened
     · an olive message at the top of the Wishlists tab ("… back in stock and ready to shop"), until dismissed (or 14 days)
     · a "Back in stock" badge on those products' images */
  const READY_KEY = 'spBackInStock';
  const readyState = () => {
    let st;
    try { st = JSON.parse(localStorage.getItem(READY_KEY) || 'null'); } catch (e) { st = null; }
    if (!st || !Array.isArray(st.ids) || (st.at && Date.now() - st.at > 14 * 864e5)) st = { ids: [], seen: true, at: 0 };
    return st;
  };
  const saveReady = (st) => { try { localStorage.setItem(READY_KEY, JSON.stringify(st)); } catch (e) { /* this browser only */ } };
  const markReady = () => {
    const st = readyState();
    const W = lists();
    if (Array.isArray(W[MAIN])) {
      const live = st.ids.filter((id) => has(MAIN, id)); // gone from the wishlist (bought / removed) → no longer flagged
      if (live.length !== st.ids.length) { st.ids = live; saveReady(st); }
    }
    const root = document.documentElement;
    root.classList.toggle('sp-wl-new', !!st.ids.length && !st.seen);
    const ids = new Set(st.ids);
    document.querySelectorAll('fw2-drawer .sp-strip__item[data-vid], fw2-drawer fw2-item-row[data-id]').forEach((n) => {
      const id = vid(n.dataset.vid || n.dataset.id);
      const list = n.dataset.list || n.dataset.wishlistId || '';
      n.classList.toggle('sp-bis', ids.has(id) && (!list || list === MAIN));
    });
    document.querySelectorAll('fw2-drawer').forEach((drawer) => {
      const pane = drawer.querySelector('.fw2-pane--lists');
      if (!pane) return;
      let banner = pane.querySelector(':scope > .sp-bis-banner');
      if (!st.ids.length) { if (banner) banner.remove(); return; }
      if (!banner) {
        banner = document.createElement('div');
        banner.className = 'sp-bis-banner';
        banner.setAttribute('role', 'status');
        banner.innerHTML = '<p class="sp-bis-banner__text"></p><button type="button" class="sp-bis-banner__close">Dismiss</button>';
        banner.querySelector('.sp-bis-banner__close').addEventListener('click', () => { saveReady({ ids: [], seen: true, at: 0 }); markReady(); });
        pane.prepend(banner);
      }
      const n = st.ids.length;
      const one = n === 1 && (W[MAIN] || []).find((x) => vid(x && x.id) === st.ids[0]);
      const title = one && (one.productTitle || one.name);
      const text = title ? `Good news: ${title} is back in stock in your size and ready to shop.` : `Good news: ${n} items from your Waitlist are back in stock in your size and ready to shop.`;
      const p = banner.querySelector('.sp-bis-banner__text');
      if (p.textContent !== text) p.textContent = text;
    });
  };
  // opening the Saved drawer counts as seeing it: the red dot goes, the message stays until dismissed
  const seeReady = (drawer) => {
    if (drawer.dataset.open !== 'true') return;
    const st = readyState();
    if (st.ids.length && !st.seen) { st.seen = true; saveReady(st); document.documentElement.classList.remove('sp-wl-new'); }
  };

  /* ---------- Waitlist isn't the wishlist: the ribbon only fills for the shopper's own lists ---------- */
  const saveCount = () => {
    const b = document.querySelector('.header__icons open-wishlists-button .wishlist-count-bubble');
    const n = b ? parseInt(b.textContent, 10) : NaN;
    try { if (!Number.isNaN(n)) localStorage.setItem('spWlCount', String(n)); } catch (e) { /* this browser only */ }
  };
  const markRibbons = () => {
    saveCount();
    const W = lists();
    if (!Array.isArray(W[WAIT])) return;
    const own = new Set();
    const wait = new Set();
    Object.keys(W).forEach((k) => {
      if (k === 'WL12' || !Array.isArray(W[k])) return;
      W[k].forEach((x) => (k === WAIT ? wait : own).add(vid(x && x.id)));
    });
    document.querySelectorAll('wishlist-button, wishlist-button-pdp').forEach((b) => {
      if (b.classList.contains('sp-move-fish') || b.classList.contains('sp-notify-fish')) return;
      const v = String(b.dataset.variantId || b.dataset.preselectedId || '').split(',').map(vid).filter(Boolean);
      const waitOnly = v.some((x) => wait.has(x)) && !v.some((x) => own.has(x));
      if ((b.dataset.spWaitOnly === 'true') === waitOnly) return;
      if (waitOnly) b.dataset.spWaitOnly = 'true'; else delete b.dataset.spWaitOnly;
    });
  };
  // already on the list: tapping that size again just says so (runs before sp-notify-me.js's handler)
  document.addEventListener('click', (e) => {
    const b = e.target.closest && e.target.closest('[data-notify-me-trigger], [data-sp-notify].is-done');
    if (!b || b.closest('.sp-nm')) return;
    let size = '';
    if (!b.matches('[data-sp-notify]')) {
      const id = vid(b.dataset.variantIdNotify || b.dataset.variantId);
      const onWait = (Array.isArray(lists()[WAIT]) ? lists()[WAIT] : []).some((x) => vid(x && x.id) === id);
      if (!b.classList.contains('sp-notified') && !onWait) return;
      size = b.dataset.size || '';
    }
    e.preventDefault();
    e.stopImmediatePropagation();
    const qad = b.closest('quick-add-drawer');
    if (qad && typeof qad.close === 'function') qad.close();
    toast(`You’re already on the list${size ? ` for ${size}` : ''}. We’ll let you know.`);
  }, true);

  /* ---------- PDP: sizes they've signed up for show a tick instead of the envelope (like the cards) ---------- */
  let pdpProduct = null;
  let pdpData = null;
  const pdpTicks = async () => {
    const pi = document.querySelector('product-info[data-url]');
    if (!pi) return;
    if (!pdpProduct) {
      const url = pi.dataset.url.split('?')[0];
      pdpProduct = fetch(`${url}.js`, { headers: { Accept: 'application/json' } }).then((r) => (r.ok ? r.json() : null)).catch(() => null);
      // the theme swaps the size buttons in after a size change: put the ticks straight back
      new MutationObserver(() => { if (pdpData) applyTicks(pdpData); }).observe(pi, { subtree: true, childList: true });
    }
    const p = await pdpProduct;
    if (!p || !Array.isArray(p.variants)) return;
    pdpData = p;
    applyTicks(p);
  };
  const applyTicks = (p) => {
    const done = (() => { try { return JSON.parse(localStorage.getItem('spNotified') || '[]').map(String); } catch (e) { return []; } })();
    const wait = new Set((Array.isArray(lists()[WAIT]) ? lists()[WAIT] : []).map((x) => vid(x && x.id)));
    const on = (id) => wait.has(vid(id)) || done.includes(String(id));
    const picker = [...document.querySelectorAll('variant-selects')].find((v) => !v.closest('.card-wrapper, .product-card-wrapper-TWP, quick-add-drawer, quick-add-inline'));
    if (!picker) return;
    const groups = [...picker.querySelectorAll('[data-option-name]')];
    const norm = (x) => String(x == null ? '' : x).trim().toLowerCase();
    const names = (p.options || []).map((o) => norm((o && o.name) || o));
    const selected = names.map((n) => {
      const g = groups.find((x) => norm(x.dataset.optionName) === n);
      const c = g && g.querySelector('input:checked');
      return c ? String(c.value).trim() : null;
    });
    groups.forEach((g) => {
      const k = names.indexOf(norm(g.dataset.optionName));
      if (k < 0) return;
      g.querySelectorAll('input[data-variant-notify-me]').forEach((input) => {
        const label = picker.querySelector(`label[for="${input.id}"]`);
        if (!label) return;
        const want = selected.slice();
        want[k] = String(input.value).trim();
        const v = p.variants.find((x) => (x.options || []).every((o, i) => want[i] == null || String(o).trim() === want[i]));
        const yes = !!(v && on(v.id));
        if (label.classList.contains('sp-notified') !== yes) label.classList.toggle('sp-notified', yes);
      });
    });
    document.documentElement.dataset.spTicks = 'ready';
  };
  const watchRibbons = () => {
    markRibbons();
    pdpTicks();
    let t = null;
    new MutationObserver(() => { clearTimeout(t); t = setTimeout(() => { markRibbons(); pdpTicks(); }, 200); })
      .observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['data-is-added', 'data-variant-id'] });
  };

  /* ---------- V3 · header count: shown only once Fish has loaded and the number has stopped changing ---------- */
  let countShown = false;
  const showCount = () => {
    if (countShown) return;
    countShown = true;
    document.documentElement.classList.add('sp-wl-ready');
  };
  const settleCount = () => {
    if (countShown) return;
    let t = null;
    const arm = () => { clearTimeout(t); t = setTimeout(() => { obs.disconnect(); showCount(); }, 900); };
    const obs = new MutationObserver((muts) => {
      if (muts.some((m) => {
        const n = m.target.nodeType === 1 ? m.target : m.target.parentElement;
        return n && n.closest && n.closest('.header__icons open-wishlists-button');
      })) arm();
    });
    obs.observe(document.body, { subtree: true, childList: true, characterData: true });
    arm();
  };

  const startTidy = async () => {
    const end = Date.now() + 15000;
    while (Date.now() < end && !(window.FishWishlist && window.FishWishlist.wishlists && Array.isArray(window.FishWishlist.wishlists[WAIT]))) await sleep(500);
    settleCount(); // the header count shows once it's the real number and has stopped changing
    markReady();
    watchRibbons();
    await sleep(1500); // let Fish finish its first render
    await tidyWaitlist();
    markRibbons();
    pdpTicks();
  };

  // a toast's "View" / "Change" chooses the tab before the drawer opens
  document.addEventListener('click', (e) => {
    const a = e.target.closest && e.target.closest('.sp-wl-toast__action');
    if (!a) return;
    const t = a.closest('.sp-wl-toast');
    const text = t ? t.textContent : '';
    next = /on the list|waitlist/i.test(text) ? 'waitlist' : 'lists';
  }, true);

  const watch = (drawer) => {
    if (drawer.dataset.spTabsBound) return;
    drawer.dataset.spTabsBound = 'true';
    let t = null;
    new MutationObserver((muts) => {
      // opening the drawer: apply a requested tab
      if (muts.some((m) => m.type === 'attributes' && m.attributeName === 'data-open') && drawer.dataset.open === 'true' && next) {
        setTab(drawer, next);
        next = null;
      }
      if (muts.every((m) => m.target.closest && m.target.closest('.sp-tabs'))) return;
      clearTimeout(t);
      t = setTimeout(() => render(drawer), 120);
    }).observe(drawer, { subtree: true, childList: true, attributes: true, attributeFilter: ['data-open'] });
    render(drawer);
  };

  /* ---------- V3 · header bookmark: always opens the Saved drawer (straight away, or the moment Fish has loaded) ---------- */
  const fishReady = () => {
    const d = document.querySelector('fw2-drawer');
    return !!(window.FishWishlist && window.FishWishlist.wishlists && d && typeof d.open === 'function') && d;
  };
  let pendingOpen = false;
  document.addEventListener('click', (e) => {
    const b = e.target.closest && e.target.closest('.header__icons open-wishlists-button');
    if (!b || !(window.spWishlist && window.spWishlist.loggedIn)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    const ready = fishReady();
    if (ready) { ready.open(); return; } // always opens on the first tap, whatever Fish has wired up yet
    if (pendingOpen) return;
    pendingOpen = true;
    document.documentElement.classList.add('sp-wl-opening');
    (async () => {
      const end = Date.now() + 10000;
      while (Date.now() < end && !fishReady()) await sleep(150);
      document.documentElement.classList.remove('sp-wl-opening');
      pendingOpen = false;
      const d = fishReady();
      if (d) d.open();
    })();
  }, true);

  /* ---------- V3 · footer "Wishlist" link: opens the Saved drawer like the header icon (sign-in sheet for guests) ---------- */
  document.addEventListener('click', (e) => {
    const a = e.target.closest && e.target.closest('footer a, .footer a');
    if (!a || a.textContent.trim().toLowerCase() !== 'wishlist') return;
    const icon = document.querySelector('.header__icons open-wishlists-button');
    if (!icon) return; // no header icon on this page: follow the link as normal
    e.preventDefault();
    icon.click();
  });

  const init = () => {
    const bindSave = () => document.querySelectorAll('atw-drawer:not([data-sp-sort-bound])').forEach((d) => {
      d.dataset.spSortBound = 'true';
      let t = null;
      new MutationObserver(() => { clearTimeout(t); t = setTimeout(sortSaveDrawer, 60); }).observe(d, { subtree: true, childList: true });
      sortSaveDrawer();
    });
    const bind = () => { document.querySelectorAll('fw2-drawer:not([data-sp-tabs-bound])').forEach(watch); bindSave(); };
    bind();
    pdpTicks(); // this device's sign-ups straight away; the Waitlist joins in when Fish loads
    setTimeout(() => { document.documentElement.dataset.spTicks = 'ready'; }, 1500);
    setTimeout(showCount, 8000); // never hide the count for long
    if (!(window.spWishlist && window.spWishlist.loggedIn)) setTimeout(settleCount, 1500); // guests: no Waitlist to wait for
    startTidy();
    [500, 1500, 4000].forEach((ms) => setTimeout(bind, ms)); // Fish adds its drawer after the page loads
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
/* ---------- V3 · ?wishlist=open (old /pages/wishlist links): open the Saved drawer, or the sign-in sheet for guests ---------- */
(() => {
  const params = new URLSearchParams(location.search);
  const fromHash = location.hash === '#wishlist';
  if (params.get('wishlist') !== 'open' && !fromHash) return;
  params.delete('wishlist');
  const query = params.toString();
  history.replaceState(null, '', location.pathname + (query ? `?${query}` : '') + (fromHash ? '' : location.hash));
  const start = () => {
    let tries = 0;
    const timer = setInterval(() => {
      const icon = document.querySelector('.header__icons open-wishlists-button');
      if (icon) { clearInterval(timer); icon.click(); return; }
      if (++tries > 40) clearInterval(timer);
    }, 250);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();